"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BALANCE_OF_NO_ADDRESS = exports.ERROR_GETTING_ALLOWANCE = exports.ERROR_GETTING_BALANCE_OF = exports.ERROR_GETTING_TOTAL_SUPPLY = exports.ERROR_GETTING_DECIMALS = exports.ERROR_APPROVING_ERC20 = void 0;
exports.ERROR_APPROVING_ERC20 = 'Error approving ERC20 token';
exports.ERROR_GETTING_DECIMALS = 'Error getting contract decimals';
exports.ERROR_GETTING_TOTAL_SUPPLY = 'Error getting total supply';
exports.ERROR_GETTING_BALANCE_OF = 'Error getting balance of';
exports.ERROR_GETTING_ALLOWANCE = 'Error getting allowance';
exports.BALANCE_OF_NO_ADDRESS = 'No address found to get balance';
